import { ButtonHTMLAttributes } from "react";

import { OptionButtonMenuContainer } from "./styles";

type OptionButtonMenuProps = ButtonHTMLAttributes<HTMLButtonElement>;

export function OptionButtonMenu(props: OptionButtonMenuProps) {
  return (
    <OptionButtonMenuContainer type="button" className="button" {...props} />
  );
}
